import { customElement, LitElement, property, PropertyValues } from 'lit-element';
import { html, TemplateResult } from 'lit-html';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

@customElement('lexml-emenda-comando')
export class ComandoEmendaComponent extends LitElement {
  @property({ type: Object }) emenda;

  update(changedProperties: PropertyValues): void {
    super.update(changedProperties);
  }

  buildTemplateComando(comandos: any[]): TemplateResult {
    const res = comandos?.reduce((acumulador, comando) => acumulador + `<p> ${comando.cabecalho} </p>`, '');
    return html`${res}`;
  }

  buildTemplateCitacao(citacao: any): string {
    const corpo = citacao
      .replace(/^<Citacao>/, '')
      .replace(/$<\/Citacao>/, '')
      .replaceAll('<Citacao>', '<div style="padding-left: 20px">')
      .replaceAll('</Citacao>', '</div>')
      .replaceAll('<Rotulo>', '<b>')
      .replaceAll('</Rotulo>', '</b> ')
      .replaceAll('<Omissis />', ' .........................................................................................................');

    return corpo;
  }

  render(): TemplateResult {
    const comandos = this.emenda?.comandos;
    return html`
      <style>
        lexml-emenda-comando {
          display: block;
          border: 1px solid #ccc;
          height: 100%;
          padding: 0 10px;
          margin: 0px 5px;
        }

        lexml-emenda-comando:focus {
          outline: 0;
          border: 0px solid #f1f1f1;
          -webkit-box-shadow: 0px;
          box-shadow: none;
        }

        .lexml-emenda-tituloComando {
          margin: 0;
          padding: 3px 10px 3px 10px;
          text-align: center;
          font-weight: bold;
        }

        .lexml-emenda-corpoComando {
          font-size: 14px;
        }

        .lexml-emenda-cabecalhoComando {
          padding-left: 20px;
        }

        .lexml-emenda-citacaoComando {
          padding-left: 40px;
        }

        lexml-emenda-citacaoComando p {
          text-align: justify;
        }
      </style>

      <section class="lexml-emenda-comando">
        <p class="lexml-emenda-tituloComando">Comando de emenda</p>
        <p>${(this.emenda as any)?.comandoEmenda?.cabecalhoComum}</p>

        ${comandos?.map(comando => {
          return html`
            ${unsafeHTML(
              '<div class="lexml-emenda-cabecalhoComando">' +
                comando.cabecalho +
                '</div>' +
                '<div class="lexml-emenda-corpoComando lexml-emenda-citacaoComando">' +
                this.buildTemplateCitacao(comando.citacao) +
                '</div>'
            )}
          `;
        })}
      </section>
    `;
  }
}
